import { Controller, Payload } from "../../config/controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { initialValuePainelState, PainelActions, PainelState } from "./painel.model"
import { action } from "typesafe-actions";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { Paciente, PacienteActions, PacienteState } from "../paciente/paciente.model";
import { Widgets } from "@mui/icons-material";
import { isEmpty } from "../../services/utils";

export interface PainelViewProps {
    painelState: PainelState
    painelActions: PainelActions

}

var myWindow: any = window as any;
myWindow.ReactNativeWebView = {
    postMessage:(msg:any) => void(0)
}

class PainelController extends Controller<any, PainelState, PainelActions> {
    synth = window.speechSynthesis;
    voices: SpeechSynthesisVoice[] = [];
    audio: any = document.getElementById("audio");
    constructor() {
        super("painel", initialValuePainelState);
        this.actionsType = {
            ...this.actionsType,
            readPacientesBySitChamouToday: `@${this.moduloName}/READ_PACIENTE_SIT_CHAMOU_TODAY`,
            setChamarPacientes: `@${this.moduloName}/SET_CHAMAR_PACIENTES`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            readPacientesBySitChamouToday: () => action(this.actionsType.readPacientesBySitChamouToday),
            setChamarPacientes: (pacientes) => action(this.actionsType.setChamarPacientes, { pacientes }),

        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.readPacientesBySitChamouToday, this.readPacientesBySitChamouTodayEffects.bind(this)),
            takeLatest(this.actionsType.setChamarPacientes, this.setChamarPacientesEffects.bind(this))

        ]
        
        this.onDeviceReady.bind(this);
    }


    private * readPacientesBySitChamouTodayEffects(actions: Payload) {
        try {
            console.log("chamou readPacientesBySitChamouTodayEffects")
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, msg: "Buscando pacientes chamando...", status: "", },
                this.actionsType.readPacientesBySitChamouToday
            ))

            let data = new Date();
            data.setHours(0, 0, 0);
            let dtIni = data.toISOString();
            data.setHours(23, 59, 59);
            let dtFim = data.toISOString()

            var resp: ResultDb<Paciente> = yield call(this.db.filter, {
                fieldsFilter: [
                    { fieldName: "type", mangoQuery: "$eq", fieldValue: "paciente" },
                    { fieldName: "situacao", mangoQuery: "$ne", fieldValue: "AGUARDANDO" },//diferente de AGUARDANDO
                    {
                        fieldName: "dt_hr_chegada", mangoQuery: "$and", fieldValue: [{
                            "$gte": dtIni,
                            "$lte": dtFim,
                        }]
                    },
                ],
                indexName: "idx_paciente_chamando_by_data"
            })
            console.log("resp readPacientesBySitChamouTodayEffects", resp)
            if (resp.status === "ok") {
                if (resp.rows && resp.rows.length > 0) {
                    let rowsCalling: Paciente[] = resp.rows.filter((row: Paciente) => row.chamando)
                    let rowsCallDone: Paciente[] = resp.rows.filter((row: Paciente) => !row.chamando)
                    yield put(this.reducer.resultAfterEffects(
                        {
                            ...this.state, loadingRows: false, status: "ok",
                            rows_calling: [...this.state.rows_calling, ...rowsCalling],
                            rows_call_done: rowsCallDone,
                            changeList: new Date().toISOString()
                        },
                        this.actionsType.readPacientesBySitChamouToday
                    ))
                    if (rowsCalling.length > 0)
                        yield put(this.reducer.actions.setChamarPacientes(rowsCalling))

                } else {
                    //simplesmente conclui
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loadingRows: false, status: "ok" },
                        this.actionsType.readPacientesBySitChamouToday
                    ))

                }
                //separar em duas listas
                //uma lista com a propriedade chamando == true e outra false,
                //a lista com false, fica exibindo em ultimas chamadas
                //a com true, sera colocado em um loop com um time
                //todos que passarem pelo time, irar acionar a tela chamando
                //apos o time finalizar, o chamando sera atualizado para false
                //sera removido da lista true e adicionado a lista false
            }

        } catch (error: any) {
            console.log("error readPacientesBySitChamouToday", error);
            let msg = "Ops, ocorreu uma falha em readPacientesBySitChamouToday, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.readPacientesBySitChamouToday
            ))
        }
    }

    loadVoices() {
        this.voices = window.speechSynthesis.getVoices() || [] as SpeechSynthesisVoice[];
        console.log("Voices loaded:", this.voices);
    }

    onDeviceReady() {
        console.log("Device is ready, initializing speech synthesis...", this.synth);
        if ('speechSynthesis' in window && typeof window.speechSynthesis.getVoices === 'function') {
            this.loadVoices();
            if ('onvoiceschanged' in window.speechSynthesis) {
                // Chrome loads voices asynchronously
                window.speechSynthesis.onvoiceschanged = this.loadVoices.bind(this);
            } else {
                // We need to attempt to load twice especially for https://github.com/macdonst/SpeechSynthesisPlugin
                setTimeout(this.loadVoices.bind(this), 3000);
            }
        }
    }

    setChamando = async (paciente: Paciente): Promise<ResultDb<Paciente>> => {
        try {
            const chamar = () => {
                let texto = `Atenção, chamando paciente ${paciente.nome} na ${paciente.atendimento.sala_desc} para o atendimento com ${paciente.atendimento.medico.nome}.`
                try {
                    if (typeof SpeechSynthesisUtterance !== "undefined") {
                        console.log("SpeechSynthesisUtterance esta definido",SpeechSynthesisUtterance)
                        const utterThis = new SpeechSynthesisUtterance(texto);
                        console.log("list voices", this.voices);
                        utterThis.voice = this.voices.find(voice =>
                            voice.lang === "pt-BR"
                        )!
                        this.synth.speak(utterThis);
                        utterThis.onpause = (event) => {
                            const char = event.utterance.text.charAt(event.charIndex);
                            console.log(
                                `Speech pausado no caracter ${event.charIndex} de "${event.utterance.text}", qual é "${char}".`,
                            );
                        };
                    } else {
                        console.log("SpeechSynthesisUtterance nao esta definido",SpeechSynthesisUtterance)
                        window.postMessage(texto);
                    }

                } catch (error: any) {
                    console.log("error chamar paciente", error);
                    let scriptElement = document.getElementById("function_speak_text");
                    console.log("scriptElement", scriptElement)
                    if (scriptElement) {                         
                        
                        console.log("chamou a funcao speakText da webview",scriptElement.textContent)
                        
                    }
                    
                }
            }
            console.log("tocou o som")
            let promissePlay = this.audio.play();
            if (promissePlay !== undefined) {
                promissePlay.then(() => {
                    // Autoplay started!
                    console.log("Permitiu repoduzir")
                }).catch((error: any) => {
                    console.log("Nao permite reproduzir audio", error)
                    console.log(window.PermissionStatus, window.Permissions)
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                });
            }

            await new Promise(resolve => {
                setTimeout(() => {
                    chamar();
                    resolve(true);
                }, 3100)
            })

            console.log("Aguardar 5 segundos")
            let resp: any = await new Promise(resolve => {
                setTimeout(() => {
                    console.log("Fim dos 5 segundos")
                    resolve(true);
                }, 5000)
            })


            console.log("chamou o paciente e sai")
            return { status: "ok", msg: resp }

        } catch (error: any) {
            console.log("error setChamando", error);
            let msg = "Ops, ocorreu uma falha em setChamando, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            return { status: "error", msg: err }
        }
    }

    private * setChamarPacientesEffects(actions: Payload) {
        try {
            let pacientes = actions.payload.pacientes as Paciente[];
            for (let idx = 0; idx < pacientes.length; idx++) {
                const paciente = pacientes[idx];
                //ativar o painel modo chamando
                let chamarPaciente: any = {
                    paciente: paciente, chamando: true
                }
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, chamando_paciente: chamarPaciente },
                    this.actionsType.setChamarPacientes
                ))
                //fazer o chamado
                console.log("fez o chamado do paciente", paciente)
                let resp: ResultDb<Paciente> = yield call(this.setChamando, paciente)
                if (resp.status === "ok") {
                    //remover paciente da lista de chamando
                    let rows_calling = [...this.state.rows_calling];
                    let idx = rows_calling.findIndex(value => value._id === paciente._id);
                    rows_calling.splice(idx, 1);
                    console.log("Aguardar 5 segundos")
                    yield delay(10000)
                    yield put(this.reducer.resultAfterEffects(
                        {
                            ...this.state, chamando_paciente: { paciente: {} as Paciente, chamando: false },
                            rows_calling: rows_calling
                        },
                        this.actionsType.setChamarPacientes
                    ))

                    //atualizar paciente, o horario chamado, e chamando false
                    paciente.chamando = false;
                    paciente.dt_hr_chamada = new Date().toISOString();

                    yield call(this.db.salvar, paciente);


                    console.log("proximo")
                }
            }

        } catch (error: any) {
            console.log("error setChamarPacientes", error);
            let msg = "Ops, ocorreu uma falha em setChamarPacientes, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.setChamarPacientes
            ))
        }
    }

}

export const painelController = new PainelController()

export const mapStateToPainelProps = (state: ApplicationState) => ({
    painelState: state.painelState,
})

export const mapDispatchToPainelProps = (dispatch: Dispatch) => ({
    painelActions: bindActionCreators({ ...painelController.reducer.actions }, dispatch),
})
  
